import React, { useState, useEffect } from 'react';
import { Badge } from './ui/badge';

const Topbar = ({ vesselData }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatUTC = (date) => {
    return date.toISOString().substr(11, 8);
  };

  return (
    <header 
      className="lg:col-start-2 lg:row-start-1 sticky top-0 z-40 border-b border-border/60 bg-[hsl(var(--background)/0.95)] backdrop-blur-sm"
      data-testid="topbar"
    >
      {/* Desktop Layout */}
      <div className="hidden md:flex items-center justify-between px-6 h-14">
        <div data-testid="vessel-info">
          <h2 className="text-lg font-semibold tracking-tight">RV Pelagia</h2>
          <p className="text-xs text-muted-foreground">Calypso Ridge Survey</p>
        </div>

        <div className="flex items-center gap-6" data-testid="topbar-widgets">
          <div className="flex items-center gap-5 text-sm font-mono">
            <div className="flex items-center gap-4" data-testid="vessel-coordinates">
              <div className="text-center">
                <div className="text-[10px] text-muted-foreground/60 uppercase tracking-wider mb-0.5">Lat</div>
                <div className="text-sm font-medium">{vesselData.lat.toFixed(3)}°</div>
              </div>
              <div className="text-center">
                <div className="text-[10px] text-muted-foreground/60 uppercase tracking-wider mb-0.5">Lon</div>
                <div className="text-sm font-medium">{vesselData.lon.toFixed(3)}°</div>
              </div>
            </div>
            
            <div className="h-8 w-px bg-border/50"></div>
            
            <div className="flex items-center gap-4" data-testid="vessel-movement">
              <div className="text-center">
                <div className="text-[10px] text-muted-foreground/60 uppercase tracking-wider mb-0.5">Speed</div>
                <div className="text-sm font-medium">{vesselData.speed.toFixed(1)} <span className="text-xs text-muted-foreground">kn</span></div>
              </div>
              <div className="text-center">
                <div className="text-[10px] text-muted-foreground/60 uppercase tracking-wider mb-0.5">Heading</div>
                <div className="text-sm font-medium">{Math.round(vesselData.heading)}°</div>
              </div>
            </div>
          </div>

          <div className="h-8 w-px bg-border/50"></div>

          <div className="flex items-center gap-3">
            <div className="text-center" data-testid="utc-clock">
              <div className="text-[10px] text-muted-foreground/60 uppercase tracking-wider mb-0.5">UTC</div>
              <div className="text-sm font-mono font-medium">{formatUTC(currentTime)}</div>
            </div>
            <Badge 
              variant="outline" 
              className="border-emerald-400/30 text-emerald-300 bg-emerald-500/10"
              data-testid="live-badge"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse mr-1.5"></span>
              Live
            </Badge>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden px-4 py-2.5 pl-16">
        <div className="flex items-center justify-between mb-2">
          <div data-testid="vessel-info-mobile">
            <h2 className="text-base font-semibold tracking-tight">RV Pelagia</h2>
            <p className="text-[10px] text-muted-foreground">Calypso Ridge Survey</p>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-right" data-testid="utc-clock-mobile">
              <div className="text-[9px] text-muted-foreground/60 uppercase tracking-wider">UTC</div>
              <div className="text-xs font-mono font-medium">{formatUTC(currentTime)}</div>
            </div>
            <Badge 
              variant="outline" 
              className="border-emerald-400/30 text-emerald-300 bg-emerald-500/10 text-xs"
              data-testid="live-badge-mobile"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse mr-1"></span>
              Live
            </Badge>
          </div>
        </div>
        
        <div className="flex items-center justify-between text-xs font-mono" data-testid="vessel-data-mobile">
          <div className="flex items-center gap-3">
            <div>
              <span className="text-muted-foreground/60">Lat</span>{' '}
              <span className="font-medium">{vesselData.lat.toFixed(3)}°</span>
            </div>
            <div>
              <span className="text-muted-foreground/60">Lon</span>{' '}
              <span className="font-medium">{vesselData.lon.toFixed(3)}°</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div>
              <span className="font-medium">{vesselData.speed.toFixed(1)}</span>{' '}
              <span className="text-muted-foreground/60">kn</span>
            </div>
            <div>
              <span className="font-medium">{Math.round(vesselData.heading)}°</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
